export default {
  userinfo: {
    id: '',
    userId: '',
    name: '',
    userName: '',
    officeId: '',
    officeName: '',
    phone: '',
    email: '',
    avatar: '',
    powerValue: '',
    powerLevel: '',
    powerLevelName: '',
    starLevel: '',
    levelDesc: '',
    coinValue: '',
    powerIcon: '',
    diamondValue: '',
  },
  coinChangeData: {},
  levelChangeData: {},
}
